<template>
  <div ref="print">
    <div class="title">
      <h3>
        THẺ HỌC SINH <br />
        KỲ THI ABC
      </h3>
      <p><strong>Ngày: 22/08/2024</strong></p>
    </div>
    <div class="content clearfix">
      <div class="picture-content">
        <img width="150" height="200" :src="avatar" alt="Description" crossorigin="anonymous" />
      </div>
      <div class="info-content">
        <div class="row">
          <div class="left">
            Họ tên học sinh:
            <strong>{{ document.studentName }}</strong>
          </div>
          <div class="right">
            Lớp: <strong>{{ document.class }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="left">
            Ngày sinh:
            <strong>{{ document.dob }}</strong>
          </div>
          <div class="right">
            Giới tính: <strong>{{ document.gender }}</strong>
          </div>
        </div>
        <div class="row">
          <div>
            Số CCCD/ Mã định danh CD:
            <strong>{{ document.studentId }}</strong>
          </div>
        </div>
        <div class="row">
          <div>
            Mã học sinh:
            <strong>{{ document.code_short }}</strong>
          </div>
        </div>
        <div class="row">
          <div>
            Số báo danh:
            <strong>{{ document.examCode }}</strong>
          </div>
        </div>
        <div class="row">
          <div>
            Phòng thi
            <strong>{{ document.room }}</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div></div>
      <div>Hà Nội, ngày ....... tháng ....... năm 2024</div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import html2pdf from 'html2pdf.js'

export default {
  props: {
    // document: Object
  },
  data() {
    return {
      isPrinting: false,
      dialog: true,
      document: {
        avatar: {
          url: 'https://s3.ap-southeast-1.amazonaws.com/lms-qwerty.vn/05565_77583cfb3e.jpg'
        },
        studentName: 'Tôn Lương Khải',
        class: '10A2',
        dob: '10/04/1999',
        gender: 'Nam',
        studentId: '111111111',
        code_short: '111111111',
        examCode: 'AA01',
        room: 'P1'
      }
    }
  },
  computed: {
    avatar() {
      return this.document && this.document.avatar && this.document.avatar.url
        ? `${this.document.avatar.url}?somecache`
        : '/img/avatar.png'
    }
  },
  methods: {
    async exportPDF() {
      this.$loading.active = true
      const element = this.$refs.print
      const opt = {
        margin: 0,

        filename: 'student_card.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'a5', orientation: 'landscape' }
      }
      html2pdf()
        .from(element)
        .set(opt)
        .save()
      this.$loading.active = false
    }
  }
}
</script>

<style scoped>
body {
  font-family: Roboto, sans-serif;
  margin: 0 20px;
  padding: 0;
  font-size: 16px;
}
.header,
.footer {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  text-align: center;
}
.header div,
.footer div {
  width: 50%;
}
.title {
  text-align: center;
  padding-top: 20px;
}
.content {
  padding: 20px;
  text-align: left;
}
.content .row {
  display: flex;
  justify-content: space-between;
}
.content .row > div {
  padding: 5px;
}
.half {
  width: 49%;
}
.left {
  width: 59%;
}
.right {
  width: 39%;
}
ul {
  padding-left: 20px;
}
.picture-content {
  float: left;
  width: 25%;
  padding-right: 20px;
}
.info-content {
  float: right;
  width: 75%;
}
.picture-content img {
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 4;
}
.clearfix::after {
  content: '';
  clear: both;
  display: table;
}
</style>
